/*
 * user-ops.dto.ts
 */
import { eUserOpsUpdateFrom } from 'src/config/config.enum.eSystem';
import type { mtUserDto } from 'src/user/dto/user.dto';
//
export type mtUserOpsStaffVOAODto = Pick<mtUserDto, 'cpinID' | 'cpisNameLogin' | 'cpisNameFull'>;
//
export type mtUserOpsPortraitDto = Pick<mtUserDto, 'cpinID' | 'cpisNameLogin' | 'cpisNameFull' | 'cpisNameDisplay'> & {
  cpieUserUpdateFrom: eUserOpsUpdateFrom;
};
//
export const moUserOpsPortraitInit: mtUserOpsPortraitDto = {
  cpinID: 0,
  cpisNameLogin: '',
  cpisNameFull: '',
  cpisNameDisplay: '',
  cpieUserUpdateFrom: eUserOpsUpdateFrom.eUndefined,
};
//
// export type mtUserOpsUpdateDto = Pick<mtUserDto, 'cpinID' | 'cpisNameLogin' | 'cpisNameFull' | 'cpisNameDisplay'> & {
//   cpieUserUpdateFrom: eUserOpsUpdateFrom;
// };
//
// export const moUserOpsUpdateInit: mtUserOpsUpdateDto = {
//   cpinID: 0,
//   cpisNameLogin: '',
//   cpisNameFull: '',
//   cpisNameDisplay: '',
//   cpieUserUpdateFrom: eUserOpsUpdateFrom.eUndefined,
// };
//#end#
